module.exports = __webpack_public_path__ + "static/media/icon_channel_sport_tv.3c0187c1.svg";